import React from 'react';

import { Toast } from '../../components/toast';
import { RolesContextProvider } from '../../auth/roles-context/RolesContextProvider';

import { FluxibleProvider } from './fluxible-context';
import ErrorBoundary from './error-boundary';

import App from './index';

const Application = props => {
  const { context } = props;
  return (
    <ErrorBoundary>
      <FluxibleProvider value={context}>
        <RolesContextProvider>
          <>
            <App {...props} />
            <Toast />
          </>
        </RolesContextProvider>
      </FluxibleProvider>
    </ErrorBoundary>
  );
};

export default Application;
